import useFilters from "@/composables/useFilters";
import { InboxModuleType } from "@/types/inboxModule.type";
import { reactive, Ref, ref, UnwrapRef } from "@vue/composition-api";
import { ActiveFilter, StatusFilterNameType, StatusType, FilterType } from "@/types/filter.types";
import { ChatListMode } from "@saysimple-platform/dtos";

const filters: UnwrapRef<FilterType> = reactive({
    keyword: "",
    channels: [],
    tags: [],
    teams: [],
    labelIds: [],
    userIds: [],
    sortBy: "newestEntry" as ChatListMode,
    read: [],
});

const searchString = ref("");
const sortBy = ref("newestEntry" as ChatListMode);
const page = ref(1);
const activeFilter: Ref<ActiveFilter> = ref({
    page: page.value,
    keyword: searchString.value,
    sortBy: sortBy.value,
    channels: [],
    tags: [],
    teams: [],
    labelIds: [],
    userIds: [],
    status: {
        title: "New",
        name: StatusFilterNameType.NEW,
        query: {
            status: StatusType.OPEN,
            assignedUserId: null,
            assignedTeamId: null,
        },
    },
    read: [],
});

// @NOTE Thom 03-04-23: Temporary solution to save time! if changes are required, we should refactor useFilters
export default function useMessagingFilters() {
    return useFilters(filters, InboxModuleType.MESSAGING, searchString, page, activeFilter, sortBy);
}
